/** neverしか渡せない関数で、never以外を渡すとエラーになる。 switch文の網羅チェックなどに使用する。 */
export const assertNever = (n: never) => {
  throw new Error(`${n} is not never`)
}
